import { ExaminationRoom } from '@/pages/clinic/examinationRooms/columns'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse } from '@magnetar/admin-api-interfaces'

export function useAllExaminationRooms(clinicId?: string | number) {
  const { token } = useAuth()
  const { data, error, mutate } = useGet<ApiResponse<ExaminationRoom[]>>(
    token && clinicId ? `/api/clinic/${clinicId}/examination-rooms/all` : null,
    undefined,
    token ?? '',
  )

  return {
    examinationRooms: data?.data || [],
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
